(function (root, factory) {
  var cartPurchase = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = cartPurchase;
  }

  if (root && root.document) {
    root.CartPurchase = cartPurchase;
    cartPurchase.init(root.document, {
      fetch: root.fetch.bind(root),
      MutationObserver: root.MutationObserver,
      setTimeout: root.setTimeout.bind(root),
      clearTimeout: root.clearTimeout.bind(root)
    });
  }
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  var CHECKOUT_FORM = 'form[data-cart-purchase-checkout]';
  var CHECKOUT_BUTTON = '[data-cart-purchase-checkout-button]';
  var INVOICE = '[data-cart-invoice]';
  var NOTE = '[data-cart-invoice-note]';
  var STATUS = '[data-cart-purchase-status]';
  var QUANTITY = '.cart-form .qty-adjuster__value';

  function updateUrl(formAction) {
    return formAction.replace(/\/$/, '') + '/update.js';
  }

  function saveNote(fetchImpl, formAction, note) {
    return fetchImpl(updateUrl(formAction), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: note })
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('cart-note-save-' + response.status);
      }
      return response.json();
    });
  }

  function createController(documentRef, dependencies) {
    var noteDraft = null;
    var invoiceOpen = null;
    var noteRevision = 0;
    var quantityPending = false;
    var quantitySawNativeBusy = false;
    var cartUpdateCount = 0;
    var bypassSubmit = typeof WeakSet === 'function' ? new WeakSet() : [];
    var checkoutInProgress = false;
    var checkoutIdentity = null;
    var checkoutMessage = '';

    function weakHas(collection, value) {
      return collection instanceof Array ? collection.indexOf(value) !== -1 : collection.has(value);
    }

    function weakAdd(collection, value) {
      if (collection instanceof Array) {
        collection.push(value);
      } else {
        collection.add(value);
      }
    }

    function weakDelete(collection, value) {
      if (collection instanceof Array) {
        var index = collection.indexOf(value);
        if (index !== -1) collection.splice(index, 1);
      } else {
        collection.delete(value);
      }
    }

    function matches(element, selector) {
      return element && element.matches && element.matches(selector);
    }

    function cartBusy() {
      return quantityPending ||
        cartUpdateCount > 0 ||
        documentRef.body.classList.contains('updating-cart') ||
        Boolean(documentRef.querySelector('.qty-adjuster--loading')) ||
        Boolean(documentRef.querySelector('.cart-item-loading'));
    }

    function identifyForm(form) {
      if (form.id) return { id: form.id };
      return { drawer: form.classList && form.classList.contains('cart-form--checkout') };
    }

    function resolveForm(identity, fallback) {
      if (identity.id && documentRef.getElementById) {
        return documentRef.getElementById(identity.id) || fallback;
      }
      if (identity.drawer) {
        return documentRef.querySelector('form.cart-form--checkout[data-cart-purchase-checkout]') || fallback;
      }
      return fallback;
    }

    function setStatus(form, message, state) {
      var status = form.querySelector(STATUS);
      if (!status) return;
      var nextMessage = message || '';
      if (status.textContent !== nextMessage) status.textContent = nextMessage;
      if (status.hidden !== !message) status.hidden = !message;
      if (state) {
        if (!status.getAttribute || status.getAttribute('data-state') !== state) status.setAttribute('data-state', state);
      } else if (!status.hasAttribute || status.hasAttribute('data-state')) {
        status.removeAttribute('data-state');
      }
    }

    function setCheckoutBusy(form, busy) {
      var button = form.querySelector(CHECKOUT_BUTTON);
      if (!button) return;
      if (button.disabled !== busy) button.disabled = busy;
      var ariaBusy = busy ? 'true' : 'false';
      if (!button.getAttribute || button.getAttribute('aria-busy') !== ariaBusy) button.setAttribute('aria-busy', ariaBusy);
    }

    function restoreDrafts() {
      var notes = documentRef.querySelectorAll(NOTE);
      var invoices = documentRef.querySelectorAll(INVOICE);
      var index;

      if (noteDraft !== null) {
        for (index = 0; index < notes.length; index += 1) {
          if (notes[index].value !== noteDraft) notes[index].value = noteDraft;
        }
      }

      if (invoiceOpen !== null) {
        for (index = 0; index < invoices.length; index += 1) {
          invoices[index].open = invoiceOpen;
        }
      }
    }

    function nativeQuantityBusy() {
      return documentRef.body.classList.contains('updating-cart') ||
        Boolean(documentRef.querySelector('.qty-adjuster--loading')) ||
        Boolean(documentRef.querySelector('.cart-item-loading'));
    }

    function settleQuantityIfFinished() {
      if (!quantityPending) return;
      if (nativeQuantityBusy()) {
        quantitySawNativeBusy = true;
        return;
      }
      if (quantitySawNativeBusy && cartUpdateCount === 0) {
        quantityPending = false;
        quantitySawNativeBusy = false;
      }
    }

    function waitForCartIdle(timeoutMs) {
      var startedAt = Date.now();

      return new Promise(function (resolve, reject) {
        function check() {
          if (!cartBusy()) {
            resolve();
          } else if (Date.now() - startedAt >= timeoutMs) {
            reject(new Error('cart-update-timeout'));
          } else {
            dependencies.setTimeout(check, 100);
          }
        }
        check();
      });
    }

    function withTimeout(promise, timeoutMs, errorName) {
      return new Promise(function (resolve, reject) {
        var timer = dependencies.setTimeout(function () {
          reject(new Error(errorName));
        }, timeoutMs);
        promise.then(function (value) {
          dependencies.clearTimeout(timer);
          resolve(value);
        }, function (error) {
          dependencies.clearTimeout(timer);
          reject(error);
        });
      });
    }

    function saveLatestNote(identity, fallbackForm, deadline) {
      var currentForm = resolveForm(identity, fallbackForm);
      var note = currentForm.querySelector(NOTE);
      var value = noteDraft !== null ? noteDraft : (note ? note.value : '');
      var revisionBeingSaved = noteRevision;
      var remaining = deadline - Date.now();

      if (remaining <= 0) return Promise.reject(new Error('cart-note-save-timeout'));
      checkoutMessage = 'Guardando tus datos…';
      setStatus(currentForm, checkoutMessage);

      return withTimeout(
        saveNote(dependencies.fetch, currentForm.action, value),
        remaining,
        'cart-note-save-timeout'
      ).then(function () {
        if (revisionBeingSaved !== noteRevision) {
          return saveLatestNote(identity, currentForm, deadline);
        }
      });
    }

    function resumeNativeCheckout(form, submitter) {
      weakAdd(bypassSubmit, form);
      if (form.requestSubmit) {
        form.requestSubmit(submitter);
        return;
      }

      var checkoutInput = documentRef.createElement('input');
      checkoutInput.type = 'hidden';
      checkoutInput.name = 'checkout';
      checkoutInput.value = 'Checkout';
      form.appendChild(checkoutInput);
      form.submit();
    }

    function onInput(event) {
      if (!matches(event.target, NOTE)) return;
      noteDraft = event.target.value;
      noteRevision += 1;
      restoreDrafts();
    }

    function onToggle(event) {
      if (!matches(event.target, INVOICE)) return;
      invoiceOpen = event.target.open;
    }

    function onQuantityChange(event) {
      if (!matches(event.target, QUANTITY)) return;
      quantityPending = true;
      settleQuantityIfFinished();
    }

    function onCartUpdateStarted() {
      cartUpdateCount += 1;
    }

    function onCartUpdateFinished() {
      cartUpdateCount = Math.max(0, cartUpdateCount - 1);
      settleQuantityIfFinished();
    }

    function onMutation() {
      restoreDrafts();
      settleQuantityIfFinished();
      if (checkoutInProgress && checkoutIdentity) {
        var currentForm = resolveForm(checkoutIdentity, null);
        if (currentForm) {
          setCheckoutBusy(currentForm, true);
          setStatus(currentForm, checkoutMessage);
        }
      }
    }

    function onSubmit(event) {
      var form = event.target;
      var submitter = event.submitter || form.querySelector(CHECKOUT_BUTTON);

      if (!matches(form, CHECKOUT_FORM) || !matches(submitter, CHECKOUT_BUTTON)) return;
      if (weakHas(bypassSubmit, form)) {
        weakDelete(bypassSubmit, form);
        return;
      }
      event.preventDefault();
      if (checkoutInProgress) return;

      checkoutInProgress = true;
      checkoutIdentity = identifyForm(form);
      setCheckoutBusy(form, true);
      checkoutMessage = cartBusy() ? 'Actualizando tu carrito…' : 'Guardando tus datos…';
      setStatus(form, checkoutMessage);

      waitForCartIdle(15000).then(function () {
        var note = form.querySelector(NOTE);
        if (noteDraft === null) noteDraft = note ? note.value : '';
        return saveLatestNote(checkoutIdentity, form, Date.now() + (dependencies.saveTimeout || 15000));
      }).then(function () {
        return waitForCartIdle(15000);
      }).then(function () {
        var currentForm = resolveForm(checkoutIdentity, form);
        var currentSubmitter = currentForm.querySelector(CHECKOUT_BUTTON) || submitter;
        setStatus(currentForm, '');
        setCheckoutBusy(currentForm, false);
        checkoutInProgress = false;
        checkoutIdentity = null;
        resumeNativeCheckout(currentForm, currentSubmitter);
      }).catch(function (error) {
        var currentForm = resolveForm(checkoutIdentity, form);
        var message = error && /timeout/.test(error.message) ?
          'La actualización del carrito tardó demasiado. Inténtalo de nuevo.' :
          'No pudimos guardar los datos del carrito. Revisa tu conexión e inténtalo de nuevo.';
        setStatus(currentForm, message, 'error');
        setCheckoutBusy(currentForm, false);
        checkoutInProgress = false;
        checkoutIdentity = null;
      });
    }

    function init() {
      documentRef.addEventListener('input', onInput);
      documentRef.addEventListener('toggle', onToggle, true);
      documentRef.addEventListener('change', onQuantityChange);
      documentRef.addEventListener('theme:cart-update-started', onCartUpdateStarted);
      documentRef.addEventListener('theme:cart-update-finished', onCartUpdateFinished);
      documentRef.addEventListener('submit', onSubmit);

      if (dependencies.MutationObserver) {
        new dependencies.MutationObserver(onMutation).observe(documentRef.body, {
          attributes: true,
          attributeFilter: ['class'],
          childList: true,
          subtree: true
        });
      }
    }

    return {
      init: init,
      saveNote: function (formAction, note) {
        return saveNote(dependencies.fetch, formAction, note);
      },
      waitForCartIdle: waitForCartIdle
    };
  }

  function init(documentRef, dependencies) {
    createController(documentRef, dependencies).init();
  }

  return {
    createController: createController,
    init: init,
    saveNote: saveNote,
    updateUrl: updateUrl
  };
});
